import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';

var _withId = /*#__PURE__*/_withScopeId("data-v-a0ca3992");

_pushScopeId("data-v-a0ca3992");

var _hoisted_1 = {
  style: {
    "min-width": "199px"
  }
};
var _hoisted_2 = {
  "class": "logo-container"
};

var _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  "class": "logo-img"
}, null, -1);

var _hoisted_4 = {
  "class": "logo-title"
};
var _hoisted_5 = {
  "class": "dev2",
  style: {
    "flex": "1"
  }
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode("退出登录");

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_menu_item = _resolveComponent("el-menu-item");

  var _component_el_avatar = _resolveComponent("el-avatar");

  var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  var _component_el_dropdown = _resolveComponent("el-dropdown");

  var _component_el_menu = _resolveComponent("el-menu");

  var _component_el_container = _resolveComponent("el-container");

  var _component_el_header = _resolveComponent("el-header");

  return _openBlock(), _createBlock(_component_el_header, {
    style: {
      "padding": "0"
    }
  }, {
    "default": _withId(function () {
      return [_createVNode(_component_el_container, null, {
        "default": _withId(function () {
          return [_createVNode("div", _hoisted_1, [_createVNode("div", _hoisted_2, [_hoisted_3, _createVNode("div", _hoisted_4, _toDisplayString(_ctx.shortTitle), 1)])]), _createVNode("div", _hoisted_5, [_createVNode(_component_el_menu, {
            "default-active": _ctx.activeIndex,
            mode: "horizontal",
            onSelect: _ctx.handleSelect,
            "background-color": "#545c64",
            "text-color": "#fff",
            "active-text-color": "rgb(64, 158, 255)",
            style: {
              "display": "flex",
              "justify-content": "flex-end",
              "position": "static"
            }
          }, {
            "default": _withId(function () {
              return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routes, function (item) {
                return _openBlock(), _createBlock(_component_el_menu_item, {
                  index: item.path,
                  key: item.path
                }, {
                  "default": _withId(function () {
                    return [_createTextVNode(_toDisplayString(item.meta.title), 1)];
                  }),
                  _: 2
                }, 1032, ["index"]);
              }), 128)), _createVNode(_component_el_menu_item, {
                index: "4"
              }, {
                "default": _withId(function () {
                  return [_createVNode(_component_el_dropdown, {
                    onCommand: _ctx.handleAvatar
                  }, {
                    dropdown: _withId(function () {
                      return [_createVNode(_component_el_dropdown_menu, null, {
                        "default": _withId(function () {
                          return [_createVNode(_component_el_dropdown_item, {
                            command: "logout"
                          }, {
                            "default": _withId(function () {
                              return [_hoisted_6];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    "default": _withId(function () {
                      return [_createVNode(_component_el_avatar, {
                        src: _ctx.avatar,
                        shape: "square",
                        style: {
                          "background-color": "rgb(84, 92, 100)"
                        }
                      }, null, 8, ["src"])];
                    }),
                    _: 1
                  }, 8, ["onCommand"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["default-active", "onSelect"])])];
        }),
        _: 1
      })];
    }),
    _: 1
  });
});